var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMuhtemellerAgf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 40,
    viewBox: "0 0 31 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1254 9.71812L20.7506 0.343359C20.5318 0.124453 20.2331 0 19.9219 0H3.51562C1.57711 0 0 1.57711 0 3.51562V36.4844C0 38.4229 1.57711 40 3.51562 40H26.9531C28.8916 40 30.4688 38.4229 30.4688 36.4844V10.5469C30.4688 10.2273 30.3346 9.92727 30.1254 9.71812ZM21.0938 4.00102L26.4677 9.375H22.2656C21.6195 9.375 21.0938 8.8493 21.0938 8.20312V4.00102ZM26.9531 37.6562H3.51562C2.86945 37.6562 2.34375 37.1305 2.34375 36.4844V3.51562C2.34375 2.86945 2.86945 2.34375 3.51562 2.34375H18.75V8.20312C18.75 10.1416 20.3271 11.7188 22.2656 11.7188H28.125V36.4844C28.125 37.1305 27.5993 37.6562 26.9531 37.6562Z",
    fill: "#646BDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2656 16.5625H8.20312C7.55594 16.5625 7.03125 17.0872 7.03125 17.7344C7.03125 18.3816 7.55594 18.9062 8.20312 18.9062H22.2656C22.9128 18.9062 23.4375 18.3816 23.4375 17.7344C23.4375 17.0872 22.9128 16.5625 22.2656 16.5625Z",
    fill: "#646BDD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2656 21.25H8.20312C7.55594 21.25 7.03125 21.7747 7.03125 22.4219C7.03125 23.0691 7.55594 23.5938 8.20312 23.5938H22.2656C22.9128 23.5938 23.4375 23.0691 23.4375 22.4219C23.4375 21.7747 22.9128 21.25 22.2656 21.25Z",
    fill: "#646BDD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2656 25.9375H8.20312C7.55594 25.9375 7.03125 26.4622 7.03125 27.1094C7.03125 27.7566 7.55594 28.2812 8.20312 28.2812H22.2656C22.9128 28.2812 23.4375 27.7566 23.4375 27.1094C23.4375 26.4622 22.9128 25.9375 22.2656 25.9375Z",
    fill: "#646BDD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5781 30.625H8.20312C7.55594 30.625 7.03125 31.1497 7.03125 31.7969C7.03125 32.4441 7.55594 32.9688 8.20312 32.9688H17.5781C18.2253 32.9688 18.75 32.4441 18.75 31.7969C18.75 31.1497 18.2253 30.625 17.5781 30.625Z",
    fill: "#646BDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMuhtemellerAgf);
export default __webpack_public_path__ + "static/media/icon_muhtemeller_agf.10aef5a980834c39fd549eef3fc71b92.svg";
export { ForwardRef as ReactComponent };